import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { FLUSH, PAUSE, PERSIST, persistCombineReducers, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import createSagaMiddleware from 'redux-saga'

import { userLogout } from '@/redux/auth/actions'
import { httpClient } from '@/services/httpClient'
import reducers from './reducers'
import rootSaga from './rootsaga'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth']
}

// Reducers
const allReducers = {
  ...reducers
}

const persistedRootReducer = persistCombineReducers(persistConfig, allReducers)

// Middleware
const sagaMiddleware = createSagaMiddleware()
const middleware = [
  ...getDefaultMiddleware({
    // To avoid reduxjs/toolkit with persist intergration
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, 'EDIT_SINGLE_ARTWORK_REQUEST']
    }
  }),
  sagaMiddleware
]

// Store
export type RootState = ReturnType<typeof persistedRootReducer>;

const store = configureStore({
  reducer: persistedRootReducer,
  middleware,
  devTools:
    process.env.NODE_ENV === 'development' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__()
})

const persistor = persistStore(store)

sagaMiddleware.run(rootSaga)

httpClient.interceptors.response.use(
  res => res,
  async err => {
    const error = err.toJSON()
    if (error?.status === 401) {
      store.dispatch(userLogout())
    }

    return Promise.reject(err)
  }
)

export { persistor, store }
